var GA;

import jQuery from 'jquery';
import Cookies from 'js-cookie';
import scrollAnchor from '@spinnwerk/scroll-helper/scroll-anchor';
import PJAX from './lib/pjax.js';
import Swiper from './lib/swiper.js';
import objectfit from './polyfill/object-fit.js';

// ////////////////////////////////////////////////////////////
// Foundation 6
/*eslint-disable lines-around-comment */
import 'foundation-sites/js/foundation.core';

import 'foundation-sites/js/foundation.util.box';
import 'foundation-sites/js/foundation.util.keyboard';
import 'foundation-sites/js/foundation.util.mediaQuery';
import 'foundation-sites/js/foundation.util.motion';
import 'foundation-sites/js/foundation.util.nest';
// import 'foundation-sites/js/foundation.util.timerAndImageLoader';
import 'foundation-sites/js/foundation.util.touch';
import 'foundation-sites/js/foundation.util.triggers';

// import 'foundation-sites/js/foundation.abide';
// import 'foundation-sites/js/foundation.accordion';
// import 'foundation-sites/js/foundation.accordionMenu';
// import 'foundation-sites/js/foundation.drilldown';
// import 'foundation-sites/js/foundation.dropdown';
// import 'foundation-sites/js/foundation.dropdownMenu';
// import 'foundation-sites/js/foundation.equalizer';
// import 'foundation-sites/js/foundation.interchange';
// import 'foundation-sites/js/foundation.magellan';
import 'foundation-sites/js/foundation.offcanvas';
// import 'foundation-sites/js/foundation.orbit';
import 'foundation-sites/js/foundation.reveal';
// import 'foundation-sites/js/foundation.slider';
// import 'foundation-sites/js/foundation.sticky';
import 'foundation-sites/js/foundation.tabs';
import 'foundation-sites/js/foundation.toggler';
// import 'foundation-sites/js/foundation.tooltip';

// import 'foundation-sites/js/foundation.responsiveMenu';
// import 'foundation-sites/js/foundation.responsiveToggle';
/*eslint-enable lines-around-comment */

jQuery(($) => {
    $(document).foundation();

    //$('.nav > ul > li a').addClass('no-scroll');
    //$('.nav > ul > li a').attr('href', '');

    var pjax = new PJAX({
        linkSelector: 'a:not(.browser-alert__close)',
        classes: {
            container: 'pjax-container',
            content: 'pjax-content',
            fragment: 'page-detail',
            closeButton: 'page-detail__close',
            containerVisible: 'pjax-container--visible',
            languageSwitcher: 'language-switcher',
            containerLoading: 'pjax-container--loading'
        },
        onAfterInit: function() {
            $('a[href="#no-link"]').on('click', function(e) {
                e.preventDefault();
            });
        },
        onReInit: function() {
            scrollAnchor({
                scrollOffset: -50 // scroll over the utility-bar
            });

            Swiper.init();

            objectfit();
        }
    });

    // you can listen to breakpoint changes like so:
    // $(window).on('changed.zf.mediaquery', (event, current, old) => {
    //     console.log(`Breakpoint changed from "${old}" to "${current}"`);
    // });

    // enable tab navigation in desktop dropdown menu
    $('.nav ul ul li a').focusout(function() {
        $(this).parents('ul').eq(1).removeClass('is-visible');
    }).focusin(function() {
        $(this).parents('ul').eq(1).addClass('is-visible');
    });

    $('.nav ul li').mouseleave(function() {
        if ($(this).children('ul').length) {
            $(this).parents('ul').eq(0).removeClass('is-visible');
        }
    }).mouseenter(function() {
        if ($(this).children('ul').length) {
            $(this).parents('ul').eq(0).addClass('is-visible');
        }
    });

    // remove widget on close click
    if (Cookies.get('closed-widget') === undefined) {
        $('.widget').show();
    }

    $('.widget__close').click(function(event) {
        event.preventDefault();
        Cookies.set('closed-widget', true, {expires: 0.025});
        $('.widget').remove();
    });

    let $win = $(window),
        $doc = $(document),
        $body = $('body'),
        $mainNav = $('.main-nav'),
        $inputs = $('input'),
        $pageWrapper = $('.page-detail--wrapper'),
        lastScrollOffset = window.pageYOffset,
        minScrollOffset = 0,
        hideMainNav = false,
        $tinyLogo = $('.logo--tiny'),
        $offCanvas = $('.off-canvas-wrapper-inner'),
        closeButtonLoop = function() {
            let loop = function() {
                pjax.initCloseButton();

                setTimeout(function() {
                    loop();
                }, 250);
            };

            loop();
        },
        updateMobileNavPosition = function(scrollTop, force) {
            if (typeof force !== 'undefined' && force === true) {
                $mainNav.css({ top: scrollTop + 50 });
                $('#off-canvas').css({ top: scrollTop });
                return;
            }

            if (!$offCanvas.hasClass('is-open-right')) {
                $mainNav.css({ top: 50 });
            } else {
                $mainNav.css({ top: scrollTop + 50 });
            }
        },
        showHideHeader = scrollTop => {
            // when scrolling down, add the indicator class, remove it on scroll up
            // the extra 50px offset is for mac and mobile devices, where the scrolling "bounces" at the top and bottom edges
            // and thus let the main-nav (dis)appear again

            minScrollOffset = $mainNav.height() + 50; // utility nav

            hideMainNav = ((scrollTop >= minScrollOffset  && scrollTop > lastScrollOffset)
                || scrollTop > $doc.height() - $win.height() - minScrollOffset)
                && !$offCanvas.hasClass('is-off-canvas-open');

            if (hideMainNav === true) {
                if (Math.abs(lastScrollOffset - scrollTop) > minScrollOffset) {
                    lastScrollOffset = scrollTop;

                    $mainNav.toggleClass('main-nav--hidden', hideMainNav);
                    $body.toggleClass('main-nav-visible', !hideMainNav);

                    $tinyLogo.stop().fadeTo(100, 1);
                    $('.' + pjax.classes.closeButton).removeClass('page-detail__close--down');
                }
            } else {
                lastScrollOffset = scrollTop;

                $mainNav.toggleClass('main-nav--hidden', hideMainNav);
                $body.toggleClass('main-nav-visible', !hideMainNav);

                $tinyLogo.stop().fadeTo(100, 0);
                $('.' + pjax.classes.closeButton).addClass('page-detail__close--down');
            }
        },
        adjustOffCanvasPos = scrollTop => {
            $('#off-canvas').css('top', scrollTop);

            updateMobileNavPosition(scrollTop);
        };

    closeButtonLoop();

    $('.menu-toggle').on('click', function() {
        setTimeout(function() {
            updateMobileNavPosition(window.pageYOffset, true);
        }, 550);
    });

    $inputs.on('focusin focus', function() {
        window.scrollTo(0, window.pageYOffset);
        document.body.scrollTop = window.pageYOffset;
    });

    $pageWrapper.on('scroll', function() {
        if (!pjax.closing) {
            showHideHeader($pageWrapper.scrollTop());
            adjustOffCanvasPos($pageWrapper.scrollTop());
        }
    });

    $(window).on('scroll', function() {
        if (!pjax.closing) {
            showHideHeader(window.pageYOffset);
            adjustOffCanvasPos(window.pageYOffset);
        }
    });

    // only if pjax was initalized
    if (pjax.DOM.$container) {
        pjax.DOM.$container.on('scroll', function() {
            if (!pjax.closing) {
                showHideHeader(pjax.DOM.$container.scrollTop());
                adjustOffCanvasPos(pjax.DOM.$container.scrollTop());
            }
        });
    }
});

// ////////////////////////////////////////////////////////////
// init and config GA
import GoogleAnalytics from '@spinnwerk/google-analytics';
GA = new GoogleAnalytics();

// ////////////////////////////////////////////////////////////
// browser alerts
import oldBrowserAlert from './lib/alerts/old-browser.js';
oldBrowserAlert({ GA: GA });

import cookieInfoAlert from './lib/alerts/cookies-info.js';
cookieInfoAlert();

// ////////////////////////////////////////////////////////////
// svg polyfills & fallbacks
require.ensure([], function() {
    // svg fallbacks for not supporting browsers
    var svgFallback = require('@spinnwerk/svg-helper/svg-fallback').default;

    svgFallback({
        fallbackPngPath: '/assets/svg/fallbacks/'
    });
}, 'svg-helper');

// ////////////////////////////////////////////////////////////
// scroll events
scrollAnchor({
    scrollOffset: -50 // scroll over the utility-bar
});

// ////////////////////////////////////////////////////////////
// form helpers
import './lib/form.js';
import './lib/language-switcher.js';
import './lib/datepicker.js';



// WEBPACK FOOTER //
// ./resources/assets/js/app.js